module.exports = __webpack_public_path__ + "img/R6__0594.13041646.jpg";